.root { display: flex; flex-direction: column; gap: 14px; min-width: 0; }
.head { display: flex; align-items: center; gap: 12px; min-width: 0; }
.back { width: 34px; height: 34px; flex-shrink: 0; border: 1px solid var(--bd); border-radius: 10px; background: var(--card); color: var(--tx); cursor: pointer; display: inline-flex; align-items: center; justify-content: center; }
.title { margin: 0; font-size: 22px; font-weight: var(--fw-title); letter-spacing: -0.02em; white-space: nowrap; }
.name { min-width: 0; font-size: 15px; color: var(--tx2); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.pill, .lock { display: inline-flex; align-items: center; gap: 6px; height: 22px; flex-shrink: 0; padding: 0 8px; border-radius: 7px; font-size: 12px; font-weight: var(--fw-label); white-space: nowrap; }
.pill { background: var(--ctl); color: var(--c); }
.pill i { width: 6px; height: 6px; border-radius: 3px; background: var(--c); }
.lock { gap: 5px; background: var(--ctl); color: var(--tx2); }
.l_ok { --c: var(--ok); }
.l_due { --c: var(--warn); }
.l_end { --c: var(--err); }
.l_off { --c: var(--lb); }
.grow { flex-grow: 1; }
.cols { display: flex; gap: 14px; align-items: flex-start; }
.left { flex: 1 1 0; min-width: 0; display: flex; flex-direction: column; gap: 14px; }
.right { width: 380px; flex-shrink: 0; display: flex; flex-direction: column; gap: 14px; }
.card { border-radius: 16px; background: var(--card); box-shadow: var(--sh); }
.cardHead { display: flex; align-items: center; gap: 8px; min-height: 56px; padding: 8px 10px 4px 20px; box-sizing: border-box; }
.cardIco { display: flex; color: var(--tx2); }
.h2 { margin: 0; font-size: 15px; font-weight: var(--fw-title); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.fold { margin-left: auto; width: 32px; height: 32px; border: 0; border-radius: 9px; background: transparent; color: var(--tx2); cursor: pointer; display: flex; align-items: center; justify-content: center; }
.fold svg { transition: transform 160ms; }
.up { transform: rotate(180deg); }
@media (prefers-reduced-motion: reduce) { .fold svg { transition: none; } }
.fold:focus-visible, .back:focus-visible, .act:focus-visible, .list a:focus-visible { outline: 2px solid var(--pri); outline-offset: 1px; }
.sum { padding: 0 20px 14px 46px; color: var(--tx2); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.rot, .list { list-style: none; margin: 0; padding: 2px 20px 14px; display: flex; flex-direction: column; }
.rot li { display: flex; align-items: center; gap: 12px; min-height: 36px; border-top: 1px solid var(--line); }
.rot li:first-child, .list li:first-child { border-top: 0; }
.rotVn { background: var(--pri-bg); }
.seq { width: 22px; color: var(--lb); font-size: 12px; text-align: right; }
.vn { color: var(--link); }
.rotTt { margin-left: auto; font-size: 12px; color: var(--lb); }
.note { padding: 0 20px 14px; font-size: 12px; color: var(--lb); }
.list li { display: flex; align-items: center; gap: 12px; min-height: 44px; border-top: 1px solid var(--line); }
.list li > b { flex-shrink: 0; min-width: 96px; font-weight: var(--fw-label); }
.list li > span { min-width: 0; color: var(--tx2); }
.col { flex-direction: column; align-items: flex-start !important; justify-content: center; gap: 2px !important; padding: 8px 0; }
.at { font-size: 12px; color: var(--lb); }
.err { color: var(--err) !important; }
.warn { color: var(--warn) !important; }
.tdot { width: 8px; height: 8px; flex-shrink: 0; border-radius: 50%; background: var(--c); }
.t_warn { --c: var(--warn); }
.t_err { --c: var(--err); }
.t_lb { --c: var(--lb); }
.t_ok { --c: var(--ok); }
.tx { flex: 1 1 0; display: flex; flex-direction: column; min-width: 0; }
.tx b { font-weight: var(--fw-label); }
.tx span { font-size: 12px; color: var(--lb); }
.act { flex-shrink: 0; height: 30px; padding: 0 12px; border: 1px solid var(--bd); border-radius: 9px; background: var(--card); color: var(--tx); font: inherit; font-size: 12px; font-weight: var(--fw-label); cursor: pointer; }
.dl { margin: 0; padding: 2px 20px 14px; }
.dl > div { display: flex; align-items: center; gap: 12px; min-height: 44px; border-top: 1px solid var(--line); }
.dl > div:first-child { border-top: 0; }
.dl dt { width: 104px; flex-shrink: 0; font-size: 12px; color: var(--lb); }
.dl dd { margin: 0; min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.lbv { color: var(--lb); }
.list a { color: var(--link); text-decoration: none; }
@media (max-width: 1100px) { .cols { flex-direction: column; } .right { width: 100%; } }

.menuWrap { position: relative; flex-shrink: 0; }
.more { width: 34px; height: 34px; border: 0; border-radius: 10px; background: var(--ctl); color: var(--tx2); cursor: pointer; display: inline-flex; align-items: center; justify-content: center; }
.menu { position: absolute; right: 0; top: calc(100% + 8px); z-index: 30; width: 250px; padding: 6px; border-radius: 14px; background: var(--card); box-shadow: var(--pop); display: flex; flex-direction: column; }
.mi { display: flex; align-items: center; gap: 6px; height: 36px; padding: 0 10px; border: 0; border-radius: 9px; background: transparent; color: var(--tx); font: inherit; text-align: left; text-decoration: none; cursor: pointer; white-space: nowrap; }
.miErr { color: var(--err); }
.sep { height: 1px; margin: 4px 6px; background: var(--line); }
@media (hover: hover) { .mi:hover { background: var(--ctl); } }
